'use client'

import { useState } from 'react'
import { links } from '@/lib/const'
import Link from 'next/link'

export const BurgerMenu = () => {
  const [open, setOpen] = useState(false)
  return (
    <div className="absolute top-5 right-10  h-full z-50 lg:hidden ">
      <button
        onClick={() => setOpen(!open)}
        className="flex flex-col gap-2 cursor-pointer z-50 relative"
      >
        <span
          className={`${open ? 'rotate-45 translate-y-[5px]' : ''} block h-0.5 w-6 bg-white`}
        ></span>
        <span
          className={`${open ? 'hidden' : ''} block h-0.5 w-6 bg-white`}
        ></span>
        <span
          className={`${open ? 'rotate-135 -translate-y-[5px]' : ''} block h-0.5 w-6 bg-white`}
        ></span>
      </button>
      {open && (
        <div className="fixed -top-12 -left-6 -right-12 w-[calc(100%+6rem)] h-[calc(100vh+2rem)] z-40 bg-black/90">
          <div className="flex flex-col gap-4 mt-30 px-10">
            {links.map((link) => (
              <Link
                key={link.href}
                href={link.href}
                className="text-white"
                onClick={() => setOpen(false)}
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}
